import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

import useCurrentUser from 'hooks/useCurrentUser';
import useGlobalStore from 'hooks/useGlobalStore';

const AuthenticationGuard = () => {
    const { isAuthenticated, isLoading, user } = useAuth0();

    const { fetchCurrentUser, isLoading: isCurrentUserLoading } = useCurrentUser();

    const { getValue } = useGlobalStore({
        namespace: 'useCurrentUser'
    });

    const currentUser = getValue('currentUser');

    useEffect(() => {
        if (isAuthenticated && !currentUser && !isCurrentUserLoading && user) {
            fetchCurrentUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, fetchCurrentUser]);

    if (isLoading || isCurrentUserLoading || (isAuthenticated && !currentUser)) {
        return null;
    }

    if (isAuthenticated && currentUser) {
        return <Outlet />;
    }

    return <Navigate replace to='/login' />;
};

export default AuthenticationGuard;
